import resume from '../assets/pdf/resume.pdf'
import image1 from '../assets/png/WhatsApp Image 2026-01-14 at 6.27.29 PM.jpeg'
import image2 from '../assets/png/WhatsApp Image 2026-01-14 at 6.28.09 PM.jpeg'
import image3 from '../assets/png/WhatsApp Image 2026-01-14 at 6.32.47 PM.jpeg'


export const headerData = {
    name: 'Randhir Kumar Raj',
    title: "Developer",
    desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: image3,
    resumePdf: resume
}
